import {determineLocation} from "./determineLocation";

export async function recordPaymentAuthorization(
    clientSecret: string,
    authorizationText: string,
    authorizationVersion: string,
): Promise<void> {
    const response = await fetch(
        `${determineLocation()}/billing/payment/authorize`,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({clientSecret, accepted: true, authorizationText, authorizationVersion}),
        },
    );
    if (!response.ok) {
        const body = await response.json();
        throw new Error(typeof body.message === "string" ? body.message : "Payment authorization could not be recorded.");
    }
}
